export default "__VITE_ASSET__DML5CO8Q__"